import React, { useRef, useEffect } from 'react';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useModalContainer } from 'ui';
import ChecklistDropdown from './ChecklistDropdown';

const dropDownStyle = {
  position: "relative"
};

const DropdownChecklistWrapper = ({
  codes = [],
  onChecked,
  applyFilter,
  dropdownAbove,
  subHeader,
  onDeleteFilter,
  onClearChecked,
  onClearFilter,
  filterButtonText,
  shown,
  setShown,
  children,
  dropdownAlignRight,
  defaultOpen,
  ariaLabel,
}) => {
  const buttonRef = useRef(null);
  // Inside a ui Modal the popper must portal into the dialog's popup, not
  // <body> — see useModalContainer in ui/Modal.jsx.
  const modalContainer = useModalContainer();

  // Handle defaultOpen prop changes (e.g., when filter is newly added)
  useEffect(() => {
    if (defaultOpen && buttonRef.current) {
      setShown(true);
    }
  }, [defaultOpen, setShown]);

  const handleClickAway = (event) => {
    // Don't close if clicking on the button itself (toggle handles that)
    if (buttonRef.current && buttonRef.current.contains(event.target)) {
      return;
    }
    setShown(false);
  };

  const handleDoneButton = () => {
    setShown(false);
    if (applyFilter) {
      applyFilter();
    }
  }

  const placement = dropdownAbove ? 'top-start' : 'bottom-start';

  return (
    <div style={{ minWidth: 0 }}>
      <div style={dropDownStyle} ref={buttonRef}>
        {children /* This is the button component */ }
      </div>
      <Popper
        open={shown && Boolean(buttonRef.current)}
        anchorEl={buttonRef.current}
        container={modalContainer}
        placement={placement}
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 40],
              },
            },
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
              },
            },
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['bottom-end', 'top-start', 'top-end'],
              },
            },
          ],
        }}
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <div>
            <ChecklistDropdown
              onDoneButton={handleDoneButton}
              onChecked={onChecked}
              codes={codes}
              subHeader={subHeader}
              onDeleteFilter={onDeleteFilter}
              onClearChecked={onClearChecked}
              onClearFilter={onClearFilter}
              filterButtonText={filterButtonText}
              ariaLabel={ariaLabel}
            />
          </div>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default DropdownChecklistWrapper;
